<div class="container-md pb-4 p-md-0">
  <div class="row g-4">
    <div class="col col-12">
      <ts-asset-card
        header="{{ 'selected_line' | translate }}"
        [asset]="shopping_cart && shopping_cart.existing_asset"
        [asset_fields]="['plan', 'plan_features', 'add_on_features']"
      />
    </div>

    <ts-add-or-remove-features
      class="col col-12"
      [shopping_cart]="shopping_cart"
      (emit_cart_features)="updateCartPrice($event)"
    />

    <ts-price-summary
      [button_status]="!disable_continue_btn"
      [is_display_recurring_cost]="!!(valid_cart && valid_cart.length)"
      [navigate_page]="navigate_page"
      [shopping_cart]="shopping_cart"
      [shopping_items_price]="shopping_items_price"
      [refresh_summary]="refresh_summary.asObservable()"
      (updateCostSummary)="getShoppingCartData($event)"
    />
  </div>
</div>
